import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, Input, Output, signal } from '@angular/core';
import { CardComponent } from '@microsec/components';
import { BaseComponent } from '@ids-components';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MOMENT_DATETIME } from '@microsec/constants';
import moment from 'moment';
import { AnomalyAnalyzerService } from '@ids-services';
import { finalize } from 'rxjs';
import { STATUSES } from '../tip-config.component';

@Component({
  selector: 'app-update-analyzer-rules-form',
  templateUrl: './update-analyzer-rules-form.component.html',
  styleUrls: ['./update-analyzer-rules-form.component.scss'],
  imports: [CommonModule, ButtonModule, TooltipModule, CardComponent],
})
export class UpdateAnalyzerRulesFormComponent extends BaseComponent {
  @Input() isLoading = signal(false);

  @Input() tipConfig = signal<any>(null);

  @Output() getConfigDataEvent = new EventEmitter<any>();

  updateButtonMessage = computed(() => {
    switch (this.tipConfig()?.status) {
      case STATUSES.STARTING_SOON:
        return 'Manual update is disabled as the scheduled update is about to start';
      case STATUSES.IN_PROGRESS:
        return 'There is already an update in progress';
      default:
        return 'Click to update MicroIDS with the latest analyzer rules from TIP';
    }
  });

  lastUpdated = computed(() => {
    return this.tipConfig()?.last_download_sync_complete_at ? moment.utc(this.tipConfig()?.last_download_sync_complete_at).local() : null;
  });

  nextUpdate = computed(() => {
    const result = this.lastUpdated()?.clone();
    result?.add(this.tipConfig()?.download_frequency, 'hour');
    return result;
  });

  STATUSES = STATUSES;

  MOMENT_DATETIME = MOMENT_DATETIME;

  constructor(public anomalyAnalyzerSrv: AnomalyAnalyzerService) {
    super();
  }

  /**
   * Trigger analyzer rules download
   */
  updateAnalyzerRules() {
    this.isLoading.set(true);
    this.anomalyAnalyzerSrv
      .triggerTipRulesDownload()
      .pipe(
        finalize(() => {
          this.isLoading.set(false);
        }),
      )
      .subscribe({
        next: () => {
          this.showSuccessMessage('Analyzer rules download triggered successfully');
          this.getConfigDataEvent.emit({ isDefault: false, isStatusUpdated: true });
        },
        error: (err: any) => {
          this.tipConfig.set({ ...this.tipConfig(), status: STATUSES.FAIL });
          this.showErrorMessage(err);
        },
      });
  }
}
